import React, { useContext } from "react";

import classNames from "classnames";
import isEmpty from "lodash.isempty";
import { observer } from "mobx-react";
import Image from "next/legacy/image";
import styled from "styled-components";

import ComponentContext from "../../../contexts/ComponentContext";
import breakpoints from "../../constants";
import useDevice from "../../customHooks/useDevice";
import CenterCardSingleJob from "./CenterCardSingleJob";
import DefaultSingleJob from "./DefaultSingleJob";
import DescriptiveSingleJob from "./DescriptiveSingleJob";
import HeaderSingleJob from "./HeaderSingleJob";
import ImageWithHeaderSingleJob from "./ImageWithHeaderSingleJob";
import InlineDescriptiveSingleJob from "./InlineDescriptiveSingleJob";
import StickyJobDescriptionSingleJob from "./StickyJobDescriptionSingleJob";

const StyledBackButton = styled.div`
  cursor: pointer;
  height: 20px;
  width: 20px;
  z-index: 1;
  position: absolute;
  left: ${({ isMobile }) => (isMobile ? "10px" : "30px")};
  top: ${({ isMobile }) => (isMobile ? "1rem" : "3rem")};
`;

const StyledContainer = styled.div`
  max-width: ${({ isImageWithHeader }) =>
    isImageWithHeader ? "540px" : "100%"};
  margin: ${({ isImageWithHeader }) =>
    isImageWithHeader ? "auto !important" : "auto"};

  @media (min-width: ${breakpoints.TABLET}) {
    max-width: ${({ isImageWithHeader }) =>
      isImageWithHeader ? "960px" : "100%"};
  }

  @media (min-width: ${breakpoints.DESKTOP}) {
    max-width: ${({ isImageWithHeader }) =>
      isImageWithHeader ? "1210px" : "100%"};
  }
`;

function SingleJob(props) {
  const { type, gallery } = useContext(ComponentContext);
  let SingleJobComponent;

  const { isMobile } = useDevice();

  const handleGoBack = () => {
    window.history.back();
  };

  switch (type) {
    case "descriptive": {
      SingleJobComponent = DescriptiveSingleJob;
      break;
    }
    case "inlineDescriptive": {
      SingleJobComponent = InlineDescriptiveSingleJob;
      break;
    }
    case "imageWithHeader": {
      SingleJobComponent = ImageWithHeaderSingleJob;
      break;
    }
    case "largeHeader": {
      SingleJobComponent = HeaderSingleJob;
      break;
    }
    case "centerCard": {
      SingleJobComponent = CenterCardSingleJob;
      break;
    }
    case "stickyJobDescription": {
      SingleJobComponent = StickyJobDescriptionSingleJob;
      break;
    }
    default: {
      SingleJobComponent = DefaultSingleJob;
      break;
    }
  }

  if (isEmpty(gallery) || type === "stickyJobDescription") {
    return <SingleJobComponent {...props} />;
  }

  const isImageWithHeader = type === "imageWithHeader";
  const isLargeHeader = type === "largeHeader";

  const isImageInBackground = type === "centerCard";

  const jobClasses = classNames({
    "col-md-6": !isImageWithHeader && !isLargeHeader && !isImageInBackground,
    "col-md-9 col-sm-12": isImageWithHeader && !isImageInBackground,
    "col-md-12": isImageInBackground,
  });

  const imageClasses = classNames({
    "col-md-3 col-sm-0 mt-5 ps-5": isImageWithHeader,
    "col-md-6": !isImageWithHeader && !isLargeHeader,
    "d-none": isMobile,
  });

  const containerClasses = classNames({
    row: !isLargeHeader,
    "flex-row-reverse mx-5": isImageWithHeader,
  });

  return (
    <div>
      {isImageWithHeader ? (
        <StyledBackButton
          id="single-job-back-button"
          isMobile={isMobile}
          onClick={handleGoBack}
        >
          <Image
            alt="go back a page"
            layout="fill"
            objectFit="contain"
            src="/arrow-border-left-white.svg"
          />
        </StyledBackButton>
      ) : null}
      <StyledContainer
        className={containerClasses}
        id="single-job-container"
        isImageWithHeader={isImageWithHeader}
      >
        <div className={jobClasses}>
          <div
            className={`${isLargeHeader || isImageInBackground ? "" : "pe-3"}`}
          >
            <SingleJobComponent
              {...props}
              applyButtonPosition="start"
              applyButtonText="Apply Now"
              showHead={false}
            />
          </div>
        </div>
        {isLargeHeader || isImageInBackground ? null : (
          <div className={imageClasses} id="single-job-gallery">
            {gallery.map((image) => {
              return (
                <Image
                  key={image.id}
                  alt={`gallery-${image.id}`}
                  className="mb-5"
                  height={image.height}
                  layout="responsive"
                  src={image.url}
                  width={image.width}
                />
              );
            })}
          </div>
        )}
      </StyledContainer>
    </div>
  );
}

export default observer(SingleJob);
